const RemoteWorkerDashboard = () => {
  return (
    <div style={{ padding: 40 }}>
      <h1>Remote Worker Dashboard</h1>
      <p>Welcome. Features coming soon.</p>
    </div>
  );
};

export default RemoteWorkerDashboard;